import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LogoMark } from "@/components/Logo";
import api, { apiError } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setMsg("This verification link is invalid.");
      return;
    }
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        setState("ok");
      } catch (err) {
        setState("error");
        setMsg(apiError(err));
      }
    })();
  }, [token]);

  return (
    <div className="debii-shell flex flex-col px-6 py-12" data-testid="verify-email-page">
      <div className="flex-1 flex flex-col justify-center items-center text-center max-w-sm w-full mx-auto">
        <LogoMark size={52} />
        {state === "loading" && (
          <>
            <Loader2 className="mt-8 h-8 w-8 text-primary animate-spin" />
            <p className="mt-4 text-sm text-muted-foreground">Verifying your email…</p>
          </>
        )}
        {state === "ok" && (
          <>
            <div className="mt-8 h-16 w-16 rounded-2xl bg-emerald-100 flex items-center justify-center">
              <CheckCircle2 className="h-9 w-9 text-emerald-700" />
            </div>
            <h1 className="mt-5 font-display text-2xl font-bold">Email verified ✓</h1>
            <p className="mt-2 text-sm text-muted-foreground">Your Debii email address is confirmed.</p>
            <Button data-testid="verify-continue" onClick={() => navigate("/")} className="mt-6 w-full h-12 rounded-xl">Continue to Debii</Button>
          </>
        )}
        {state === "error" && (
          <>
            <div className="mt-8 h-16 w-16 rounded-2xl bg-red-50 flex items-center justify-center">
              <XCircle className="h-9 w-9 text-red-500" />
            </div>
            <h1 className="mt-5 font-display text-2xl font-bold">Link not valid</h1>
            <p className="mt-2 text-sm text-muted-foreground">{msg || "This verification link is invalid or has expired."}</p>
            <Button variant="outline" onClick={() => navigate("/")} className="mt-6 w-full h-12 rounded-xl">Open Debii</Button>
          </>
        )}
      </div>
    </div>
  );
}
